const prefix = '/assets/icons/';

export const SVG_ASSET_MAP: IAssetMap = {
  helpIcon: prefix + 'Help.svg',
  notificationIcon: prefix + 'Notification.svg',
  settingsIcon: prefix + 'Settings.svg',
  searchIcon: prefix + 'Search.svg',
  userIcon: prefix + 'User.svg',
  hamburgerIcon: prefix + 'Hamburger.svg',
  saveIcon: prefix + 'Save.svg',
  acceptIcon: prefix + 'Accept.svg',
  acceptIcon_Secondary: prefix + 'Accept_Secondary.svg',
  cancelIcon: prefix + 'Cancel.svg',
  cancelIcon_Secondary: prefix + 'Cancel_Secondary.svg',
  cancelIcon_Black: prefix + 'Cancel_Black.svg',
  deleteIcon: prefix + 'Bin.svg',
  copyIcon: prefix + 'CopyRecord.svg',
  detailsIcon: prefix + 'Details.svg',
  drawingsIcon: prefix + 'Drawings.svg',
  editIcon: prefix + 'EditDetails.svg',
  locationIcon: prefix + 'Location.svg',
  locationIcon_Secondary: prefix + 'Location_Secondary.svg',
  mapFlatIcon: prefix + 'MapFlat.svg',
  mapLocationIcon: prefix + 'MapLocation.svg',
  mapLocationIcon_Secondary: prefix + 'MapLocation_Secondary.svg',
  mapRouteIcon: prefix + 'MapRoute.svg',
  recordsIcon: prefix + 'Records.svg',
  reportingIcon: prefix + 'Reporting.svg',
  starIcon: prefix + 'Star.svg',
  zoomInIcon: prefix + 'ZoomIn.svg',
  zoomInIcon_Secondary: prefix + 'ZoomIn_Secondary.svg',
  zoomOutIcon: prefix + 'ZoomOut.svg',
  zoomOutIcon_Secondary: prefix + 'ZoomOut_Secondary.svg',
  geotechnicalIcon: prefix + 'Geotechnical.svg',
  triangleIcon: prefix + 'Triangle.svg',
  zoomToArea_Secondary: prefix + 'ZoomToArea_Secondary.svg',
  ruler_Secondary: prefix + 'Ruler_Secondary.svg',
  compass_Secondary: prefix + 'Compass_Secondary.svg',
  moreIcon: prefix + 'More.svg',
  addDetailsIcon: prefix + 'AddDetails.svg',
  compassIcon: prefix + 'Compass.svg',
  emailIcon: prefix + 'Email.svg',
  passwordIcon: prefix + 'Password.svg',
  restoreIcon: prefix + 'Restore.svg',
  rulerIcon: prefix + 'Ruler.svg',
  tabBreakoutIcon: prefix + 'TabBreakout.svg',
  tabBreakoutIcon_Black: prefix + 'TabBreakout_Black.svg',
  logoutIcon: prefix + 'Logout.svg',
  events: prefix + 'Events.svg',
  clearFilterIcon: prefix + 'ClearFilter.svg',
  clearFilterIcon_Secondary: prefix + 'ClearFilter_Secondary.svg',
  clearSelectionIcon: prefix + 'ClearSelect.svg',
  clearSelectionIcon_Secondary: prefix + 'ClearSelect_Secondary.svg',
  csvIcon: prefix + 'CSV.svg',
  csvIcon_Secondary: prefix + 'CSV_Secondary.svg',
  filterIcon: prefix + 'Filter.svg',
  filterIcon_Secondary: prefix + 'Filter_Secondary.svg',
  multiSelectIcon: prefix + 'Multi-Select.svg',
  multiSelectIcon_Secondary: prefix + 'Multi-Select_Secondary.svg',
  privacyIcon: prefix + 'Privacy.svg',
  privacyIcon_Secondary: prefix + 'Privacy_Secondary.svg',
  selectIcon: prefix + 'Select.svg',
  selectIcon_Secondary: prefix + 'Select_Secondary.svg',
  termsConditionsIcon: prefix + 'T&C.svg',
  termsConditionsIcon_Secondary: prefix + 'T&C_Secondary.svg',
  welcomeEmailIcon: prefix + 'WelcomeEmail.svg',
  welcomeEmailIcon_Secondary: prefix + 'WelcomeEmail_Secondary.svg',
  areaSelect_Secondary: prefix + 'AreaSelect_Secondary.svg'
};

export const PNG_ASSET_MAP: IAssetMap = {
  helpIcon: prefix + 'Help.png',
  notificationIcon: prefix + 'Notification.png',
  settingsIcon: prefix + 'Settings.png',
  searchIcon: prefix + 'Search.png',
  userIcon: prefix + 'User.png',
  hamburgerIcon: prefix + 'Hamburger.png',
  saveIcon: prefix + 'Save.png',
  acceptIcon: prefix + 'Accept.png',
  acceptIcon_Secondary: prefix + 'Accept.png',
  cancelIcon: prefix + 'Cancel.png',
  cancelIcon_Secondary: prefix + 'Cancel.png',
  cancelIcon_Black: prefix + 'Cancel.png',
  deleteIcon: prefix + 'Bin.png',
  copyIcon: prefix + 'Copy.png',
  detailsIcon: prefix + 'Details.png',
  drawingsIcon: prefix + 'Drawings.png',
  editIcon: prefix + 'EditDetails.png',
  locationIcon: prefix + 'Location.png',
  locationIcon_Secondary: prefix + 'Location.png',
  mapFlatIcon: prefix + 'MapFlat.png',
  mapLocationIcon: prefix + 'MapLocation.png',
  mapLocationIcon_Secondary: prefix + 'MapLocation.png',
  mapRouteIcon: prefix + 'MapRoute.png',
  recordsIcon: prefix + 'Records.png',
  reportingIcon: prefix + 'Reporting.png',
  starIcon: prefix + 'Star.png',
  zoomInIcon: prefix + 'ZoomIn.png',
  zoomInIcon_Secondary: prefix + 'ZoomIn.png',
  zoomOutIcon: prefix + 'ZoomOut.png',
  zoomOutIcon_Secondary: prefix + 'ZoomOut.png',
  geotechnicalIcon: prefix + 'Geotechnical.png',
  triangleIcon: prefix + 'Triangle.png',
  zoomToArea_Secondary: prefix + 'ZoomToArea.png',
  ruler_Secondary: prefix + 'Ruler.png',
  compass_Secondary: prefix + 'Compass.png',
  moreIcon: prefix + 'More.png',
  addDetailsIcon: prefix + 'AddDetails.png',
  compassIcon: prefix + 'Compass.png',
  emailIcon: prefix + 'Email.png',
  passwordIcon: prefix + 'Password.png',
  restoreIcon: prefix + 'Restore.png',
  rulerIcon: prefix + 'Ruler.png',
  tabBreakoutIcon: prefix + 'TabBreakout.png',
  tabBreakoutIcon_Black: prefix + 'TabBreakout.png',
  logoutIcon: prefix + 'Logout.png',
  events: prefix + 'Events.png',
  clearFilterIcon: prefix + 'ClearFilter.png',
  clearSelectionIcon: prefix + 'ClearSelect.png',
  csvIcon: prefix + 'CSV.png',
  filterIcon: prefix + 'Filter.png',
  multiSelectIcon: prefix + 'Multi-Select.png',
  privacyIcon: prefix + 'Privacy.png',
  selectIcon: prefix + 'Select.png',
  termsConditionsIcon: prefix + 'T&C.png',
  welcomeEmailIcon: prefix + 'WelcomeEmail.png',
  areaSelect_Secondary: prefix + 'AreaSelect_Secondary.svg'
};

export interface IAssetMap {
  helpIcon: string;
  notificationIcon: string;
  settingsIcon: string;
  searchIcon: string;
  userIcon: string;
  hamburgerIcon: string;
  saveIcon: string;
  acceptIcon: string;
  acceptIcon_Secondary: string;
  cancelIcon: string;
  cancelIcon_Secondary: string;
  cancelIcon_Black: string;
  deleteIcon: string;
  copyIcon: string;
  detailsIcon: string;
  drawingsIcon: string;
  editIcon: string;
  locationIcon: string;
  locationIcon_Secondary: string;
  mapFlatIcon: string;
  mapLocationIcon: string;
  mapLocationIcon_Secondary: string;
  mapRouteIcon: string;
  recordsIcon: string;
  reportingIcon: string;
  starIcon: string;
  zoomInIcon: string;
  zoomInIcon_Secondary: string;
  zoomOutIcon: string;
  zoomOutIcon_Secondary: string;
  geotechnicalIcon: string;
  triangleIcon: string;
  zoomToArea_Secondary: string;
  ruler_Secondary: string;
  compass_Secondary: string;

  moreIcon?: string;
  addDetailsIcon: string;
  compassIcon: string;
  emailIcon: string;
  passwordIcon: string;
  restoreIcon: string;
  rulerIcon: string;
  tabBreakoutIcon: string;
  tabBreakoutIcon_Black: string;
  logoutIcon: string;
  events: string;

  clearFilterIcon: string;
  clearFilterIcon_Secondary?: string;
  clearSelectionIcon: string;
  clearSelectionIcon_Secondary?: string;
  csvIcon: string;
  csvIcon_Secondary?: string;
  filterIcon: string;
  filterIcon_Secondary?: string;
  multiSelectIcon: string;
  multiSelectIcon_Secondary?: string;
  privacyIcon: string;
  privacyIcon_Secondary?: string;
  selectIcon: string;
  selectIcon_Secondary?: string;
  termsConditionsIcon: string;
  termsConditionsIcon_Secondary?: string;
  welcomeEmailIcon: string;
  welcomeEmailIcon_Secondary?: string;
  areaSelect_Secondary: string;
}
